import { gql } from '@apollo/client';

const userAttributes = `
  id
  username
  email
  givenName
  familyName
  pronouns
  about
  websiteUrl
  instagramUsername
  weeklyEventsReminder
  weekendEventsReminder
  emailMarketingPreference
  discoverable
  phoneNumber
  phoneNumberDisplay: phoneNumber(format: NATIONAL)
  primaryCityId
  primaryCity {
    id
    slug
    name
  }
  avatar {
    small {
      url
    }
  }
`;

export const accountQuery = gql`
  query AccountQuery {
    me {
      ${userAttributes}
    }
  }
`;

export const accountNotificationsQuery = gql`
  query AccountNotificationsQuery {
    me {
      ${userAttributes}
      groupMembers {
        id
        eventNotificationPreference
        postNotificationPreference
        group {
          id
          slug
          name
          found
          image {
            filename
          }
        }
      }
    }
  }
`;

export const updateProfileMutation = gql`
  mutation UpdateProfileMutation($data: ProfileInput!) {
    updateProfile(data: $data) {
      ${userAttributes}
    }
  }
`;

export const updateAccountSettingsMutation = gql`
  mutation UpdateAccountSettingsMutation($data: AccountSettingsInput!) {
    updateAccountSettings(data: $data) {
      ${userAttributes}
    }
  }
`;

export const updateAccountNotificationPreferencesMutation = gql`
  mutation UpdateAccountNotificationPreferencesMutation($data: AccountNotificationPreferencesInput!) {
    updateAccountNotificationPreferences(data: $data) {
      ${userAttributes}
    }
  }
`;

export const myUserFollowsQuery = gql`
  query MyUserFollowsQuery {
    me {
      id
      userFollows {
        id
        followingUser {
          id
          username
          displayName
          avatar {
            small {
              url
            }
          }
        }
      }
    }
  }
`;
